module.exports = __webpack_public_path__ + "74981efda63a5ee1484f37025818122b.png";